import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `InputStatusMessage` from `genesis-core` instead
 */

export const ErrorMessage = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    color="onSurface.text.critical"
    fontSize="body2"
    margin="none"
    padding="none"
    ref={ref}
    {...props}
  />
));

ErrorMessage.displayName = 'ErrorMessage';
